import React from "react";
import './payment_cashfree_hd.css'
import { useLocation } from "react-router-dom";

export default function PaymentCashfreeHD() {
    const location = useLocation()
    console.log(location)

    return (
        <div className="payment-container">
            <div className="payment-card">
                {/* Success Icon */}
                <div className="success-icon">
                    <svg
                        className="checkmark"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 52 52"
                    >
                        <circle className="checkmark-circle" cx="26" cy="26" r="25" fill="none" />
                        <path className="checkmark-check" fill="none" d="M14 27l7 7 16-16" />
                    </svg>
                </div>

                {/* Title */}
                <h1>Payment Successful 🎉</h1>
                <p>
                    Your subscription is now active. Please open the app to explore and enjoy premium OTT content without interruptions.
                </p>

                {/* Order Details */}
                <div className="order-details">
                    <p style={{ whiteSpace: "wrap" }}><strong>Timestamp:</strong> {Date()}</p>
                    {/* <p><strong>Amount Paid:</strong> ₹{Number(location?.state?.status?.order_amount).toFixed(2)}</p> */}
                    {/* <p><strong>Payment Method:</strong> Cashfree</p> */}
                </div>

                {/* Actions */}
                {/* <div className="actions">
                    <button className="btn btn-primary">Download Receipt</button>
                    <button className="btn btn-secondary">Continue Shopping</button>
                </div> */}
            </div>
        </div>
    );
}
